/* Built In Imports */
import Head from 'next/head';
import { useRouter } from 'next/router';

/* External Imports */
/* Internal Imports */
/* Components */
import config from '@config';
import { getUtmParameters } from '@utils/index.js';

/**
 * Renders the Head component
 *
 * @param {object} data - content from api
 * @param {object} availableLocals - region and country
 * @param {string} script - <script> tag in header
 * @returns {ReactElement} Head component
 */

const HeadComponent = ({ data, availableLocals, script }) => {
  // const [fonts, setFonts] = useState([]);
  const router = useRouter();
  const linkAdded = false;

  const seoFieldsHandler = () => {
    if (data?.length && typeof data !== 'string') {
      return data.map(d => {
        const newTAG = [];
        let name = '';
        let content = '';
        let property = '';
        let href = '';
        let rel = '';
        if (d.tag === 'meta') {
          Object.entries(d.attributes).map(([k, v]) => {
            name = k.trim() === 'name' ? v : name;
            content = k.trim() === 'content' ? v : content;
            property = k.trim() === 'property' ? v : property;
            if (content !== '' && name !== '') {
              newTAG.push(<meta name={name} content={content} />);
            } else if (content !== '' && property !== '') {
              newTAG.push(
                <meta key={v} content={content} property={property} />
              );
            }
          });
        }
        if (d.tag === 'link' && d.attributes !== null) {
          Object.entries(d.attributes).map(([key, value]) => {
            href = key.trim() === 'href' ? value : href;
            rel = key.trim() === 'rel' ? value : rel;
            if (href !== '' && rel !== '') {
              if (rel === 'canonical' && !href.startsWith('http')) {
                href = `${config.BASE_PATH}${href}`;
              }
              newTAG.push(<link key={value} href={href} rel={rel} />);
            }
          });
        }
        if (d.tag === 'title') {
          newTAG.push(<title>{d.content}</title>);
        }
        return newTAG;
      });
    }
  };

  const updateUtmParameters = () => {
    return getUtmParameters(router.asPath);
  };

  // const setCSSLink = () => {
  //   setTimeout(function () {
  //     if (typeof document !== 'undefined' && !linkAdded) {
  //       // console.log('linkAdded', linkAdded);
  //       linkAdded = true;
  //       const fileRef = document.createElement(`link`);
  //       fileRef.rel = `stylesheet`;
  //       fileRef.type = `text/css`;
  //       fileRef.href = `${config.staticPath}/assets/fonts/mukta-fonts.css`;
  //       document.getElementsByTagName(`head`)[0].appendChild(fileRef);
  //     }
  //   }, 1800);
  //   return null;
  // };

  return (
    <Head>
      {updateUtmParameters()}
      {seoFieldsHandler()}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <meta
        name="viewport"
        content="width=device-width, height=device-height, initial-scale=1, minimum-scale=1, maximum-scale=5, user-scalable=yes"
      />
      <meta name="MobileOptimized" content="width" />
      <meta name="HandheldFriendly" content="true" />
      <meta name="theme-color" content="#ffffff" />
      <link
        rel="icon"
        href={`${config.imgPath}/d/46272/1703153708-ihs_favicon_icon.png`}
      />
      <link
        rel="apple-touch-icon"
        href={`${config.imgPath}/d/46272/1703153708-ihs_favicon_icon.png`}
        type="image/jpg"
        sizes="16x16"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Belanosima:wght@400;600&family=Zilla+Slab:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&display=swap"
        rel="stylesheet"
      />
      {/* {setCSSLink()} */}
    </Head>
  );
};

export default HeadComponent;
